import { zfill } from './util'

// Convert seconds to a Date object at epoch date (1970-01-01) using local time
export function representTimeWithDateObject (seconds: number = 0): Date {
  const hours = Math.floor(seconds / 3600)
  const minutes = Math.floor((seconds % 3600) / 60)
  return new Date(1970, 0, 1, hours, minutes, 0, 0)
}

// Convert a Date object (local time) to total seconds since midnight
export function convertDateObjectToSeconds (date?: Date): number {
  if (!date) return 0
  return date.getHours() * 3600 + date.getMinutes() * 60 + date.getSeconds()
}

// Format UTC Date object to 'HH:mm'
export function formatDateObjectToTimeString (date: Date): string {
  return `${zfill(date.getUTCHours())}:${zfill(date.getUTCMinutes())}`
}

// Format seconds since midnight directly to 'HH:mm' (without Date conversion)
// Used to display shop working hours in shop's timezone
export function formatSecondsToTimeString (seconds: number = 0): string {
  const hours = Math.floor(seconds / 3600)
  const minutes = Math.floor((seconds % 3600) / 60)
  return `${zfill(hours)}:${zfill(minutes)}`
}

// Set specific UTC time on a Date object
export function modifyTime (
  date: Date,
  hours = 0,
  minutes = 0,
  seconds = 0
): Date {
  const d = new Date(date.getTime())
  d.setUTCHours(hours, minutes, seconds, 0)
  return d
}
